export const defaultFaqPageSetting = {
  header: 'Frequently Asked Questions',
  headerColor: '#181A1B',
  description: 'Got a question? We are here to answer!',
  descriptionColor: '#A8A8A8',
  categoryColor: '#3B3B3B',
  questionTextColor: '#303030',
  questionBackgroundColor: '#F6F6F6',
  answerTextColor: '#616161',
  answerBackgroundColor: '#FFFFFF',
  buttonTextColor: '#FFFFFF',
  bodyTextColor: '#303030BF',
  buttonBackgroundColor: '#3B3B3B',
  backgroundPage: '#FFFFFF',
  faqPageCustomCss: '',
  subtitleColor: '#616161',
  theme: 'light-faq-page',
  opacity: 8,
  layout: 'page',
  enabledBanner: false,
  bannerType: 'color',
  bannerColor: '#616161cc',
  bannerImage: '',
  contactUs: {
    header: 'Not finding what you are looking for?',
    action: 'chatbox',
    display: false,
    description: 'Chat with us or send us an email'
  },
  brandingRemoval: false,
  customUrl: 'avada-faqs',
  isBlocked: false
};
